import React from "react";
import { ToggleButton } from "@mui/lab";
import styled from "styled-components";
import { Stack } from "@mui/material";

const StyledToggleButton = styled(ToggleButton)`
    font-size: 12px;
    text-transform: none;
    border-radius: 8px;
    margin: 6px;
    font-weight: 300;
    padding-left: 8px;
    width: 257px;
    white-space: nowrap;
    overflow: hidden;
`;

const ButtonContainer = styled.div`
    margin: -6px;
    margin-top: 12px;
`;

const StartIcon = styled.img`
    width: 17px;
    margin-right: 6px;
`;

const MissionSelectionToggle = ({
    allMissions,
    selectedMissionId,
    setSelectedMissionId,
    selectedCategory,
    setMissionTarget,
}) => {
    const [missionData, setMissionData] = React.useState([]);

    const isProd = process.env.ENVIRONMENT_NAME === "prod";
    const setAssetLink = () => {
        if (!isProd) return "https://assets-sit.adadot.com/missions";
        return "https://assets.adadot.com/missions";
    };
    const assetLink = setAssetLink();

    React.useEffect(() => {
        if (selectedCategory === "work") {
            setMissionData(allMissions.work);
        } else if (selectedCategory === "collaboration") {
            setMissionData(allMissions.collaboration);
        } else if (selectedCategory === "wellbeing") {
            setMissionData(allMissions.wellbeing);
        }
    }, [selectedCategory, allMissions]);

    const handleButtonClick = (newMissionId, min) => {
        setSelectedMissionId(newMissionId);
        setMissionTarget(min);
    };

    if (missionData && missionData.length === 0) return null;

    return (
        <ButtonContainer>
            {missionData.map((button) => (
                <StyledToggleButton
                    key={button.missionId}
                    value={button.missionId}
                    selected={selectedMissionId === button.missionId}
                    onClick={() => handleButtonClick(button.missionId, button.min)}
                >
                    <Stack direction="row" style={{ width: "100%" }}>
                        <StartIcon
                            src={`${assetLink}/${selectedCategory}/${button.missionId}.svg`}
                            alt="image"
                        />
                        {button.title}
                    </Stack>
                </StyledToggleButton>
            ))}
        </ButtonContainer>
    );
};

export default MissionSelectionToggle;
